import { useIntl } from 'react-intl';
import { SectionHeading, Input } from '@ets/design-system';

import { useDispatch } from '_common/hooks';
import { openAndUpdateModal } from '_common/modals/ModalsSlice';

type TagsHeadingProps = {
  testId: string;
  search: string;
  onSearchChange: (search: string) => void;
};

const TagsHeading = ({ search, onSearchChange, testId }: TagsHeadingProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const toggleCreatingTag = () => {
    dispatch(
      openAndUpdateModal({
        modal: 'CreateNewTagModal',
        data: {},
      }),
    );
  };

  const openUploadTagsModal = () => {
    dispatch(
      openAndUpdateModal({
        modal: 'UploadTagsModal',
        data: { state: 'standby', progress: 0 },
      }),
    );
  };

  const handleSearchTag = (value: string) => {
    onSearchChange(value || '');
  };

  return (
    <SectionHeading
      className="mt-12"
      title={intl.formatMessage({ id: 'settings.general.tags' })}
      size="l"
      firstAction={{
        children: intl.formatMessage({ id: 'TITLE_NEW_TAG' }),
        variant: 'primary',
        onClick: toggleCreatingTag,
      }}
      secondAction={{
        children: intl.formatMessage({ id: 'UPLOAD_TAGS' }),
        onClick: openUploadTagsModal,
      }}
      searchBar={
        <Input
          size="m"
          prefix="search"
          placeholder={intl.formatMessage({ id: 'PLACEHOLDER_SEARCH' })}
          onChange={(e) => handleSearchTag(e.target.value)}
          value={search}
          width="31rem"
          testId={`${testId}-search`}
          className="pr-4"
        />
      }
      testId={testId}
    />
  );
};

export default TagsHeading;
